// extracted by mini-css-extract-plugin
export var wordContainer = "_qs-0";